// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IconsCell__statusCell___QpTjG {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    width: 100%;
    height: 100%;
}

.IconsCell__statusCellProjectRowControls___6t9Gi {
    display: flex;
    gap: var(--space-xs);
    align-items: center;

    height: 100%;
    padding-right: 1rem;
}

.IconsCell__statusCellProjectRowControlsRotated___H_DxT {
    transform: rotate(90deg);
}

.IconsCell__hide___Alg4I {
    display: none;
}

.IconsCell__statusCellProjectRowControls___6t9Gi:hover .IconsCell__hide___Alg4I {
    display: unset;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/ProjectsView/ProjectsGridView/IconsCell/IconsCell.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;;IAE9B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;;IAEnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".statusCell {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n\n    width: 100%;\n    height: 100%;\n}\n\n.statusCellProjectRowControls {\n    display: flex;\n    gap: var(--space-xs);\n    align-items: center;\n\n    height: 100%;\n    padding-right: 1rem;\n}\n\n.statusCellProjectRowControlsRotated {\n    transform: rotate(90deg);\n}\n\n.hide {\n    display: none;\n}\n\n.statusCellProjectRowControls:hover .hide {\n    display: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusCell": `IconsCell__statusCell___QpTjG`,
	"statusCellProjectRowControls": `IconsCell__statusCellProjectRowControls___6t9Gi`,
	"statusCellProjectRowControlsRotated": `IconsCell__statusCellProjectRowControlsRotated___H_DxT`,
	"hide": `IconsCell__hide___Alg4I`
};
export default ___CSS_LOADER_EXPORT___;
